module.exports = __webpack_public_path__ + "static/img/10017 (2).8eac4b8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10017 (2).webp
// module id = Ay7e
// module chunks = 14